
import Skeleton from '@/components/skeleton/index.vue'
import CreateDetailLayout from '@/layout/edit_layout.vue'
import RowWrap from '@/components/detail/row_wrap/index.vue'
import RowItem from '@/components/detail/row_item/index.vue'
import { Component, Vue } from 'vue-property-decorator'
import { EnterpriseService } from '@/services'
import { statusMap } from './list.vue'

@Component({
    name: '',
    components: {
        CreateDetailLayout,
        Skeleton,
        RowWrap,
        RowItem
    }
})
export default class extends Vue {
    private isLoading = true
    private detailId = ''
    private detail: any = {}

    get matchStatus() {
        const status = Object.values(statusMap).find(n => n.key === this.detail.status)
        return status ? status.name : ''
    }

    created() {
        this.$title('Loading | 详情页 - 庖丁')
        this.detailId = this.$route.params.id
    }

    async mounted() {
        this.isLoading = true
        await this.getDetail()
    }

    /** 获取详情 */
    private async getDetail() {
        const params = {
            id: +this.detailId
        }
        const result = await EnterpriseService.getInterviewDetail(params)
        if (result.status === 200) {
            // result.data
            this.detail = result.data
            this.$title(`${this.detail.title} | 采访详情 - 庖丁`)
            this.isLoading = false
        }
    }

}
